let configuredBaseURL: string = import.meta.env.VITE_API_BASE_URL || "";

export function setDesignControlsBaseURL(url: string): void {
  configuredBaseURL = url;
}

export function getDesignControlsBaseURL(): string {
  return configuredBaseURL;
}
